import Vue from 'vue'
import Vuex from 'vuex'
import auth from './Auth'
import error from './Error'
import loader from './Loader'
import modal from './Modal'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    error,
    loader,
    modal
  }
})

export default store